import React from 'react';
import Loader from '../../components/common/Loader';
import Footer from '../../components/home1/Footer';
import Menu from '../../components/innerpage/Menu';
import Navbar from '../../components/innerpage/Navbar';
import StartButton from '../../components/home5_residence/StartButton';
import Slider from '../../components/innerpage/single_post/Slider';
import Content from '../../components/innerpage/single_post/Content';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import fullPosts from "../../data/innerpages/blog/fullPost";

export default function SinglePost() {
    const { slug } = useParams();
    const blog = fullPosts.find(post => post.slug === slug);

    console.log(blog);

    if (!blog) return <div>Yazı bulunamadı.</div>;

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/innerpages.css"
        />
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/innerpages/assets/js/innerpages.js"></script>
      </Helmet>
      <body className="inner-pages-style1 post-pg-style1">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar />
          <main>
            <Slider
                title={blog.title} />
            <Content
                title={blog.title}
                slug={blog.slug}
                paragraph1={blog.paragraph1}
                paragraph2={blog.paragraph2}
                paragraph2Title={blog.paragraph2Title}
                paragraph3={blog.paragraph3}
                paragraph4={blog.paragraph4}
                paragraph4Title={blog.paragraph4Title}
                tags={blog.tags}
                relatedPosts={blog.relatedPosts}
            />
          </main>
          <Footer />
        </div>
        <StartButton />
      </body>
    </>
  );
}
